import styled from 'styled-components';

export const RichTextList = styled.ul<{ $type?: string }>`
  list-style: ${({ $type }) => $type ?? 'disc'};
  padding-left: 20px;
`;

export const RichTextNumberedList = styled.ol<{ $type?: string }>`
  list-style-type: ${({ $type }) => $type ?? 'numerical'};
  padding-left: 20px;
`;

export const RichTextBlockQuote = styled.blockquote`
  all: revert;
`;
